import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../common/config";

export const signupService = createApi({
  reducerPath: "signup",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
  }),
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (formdata) => ({
        url: "/users/register",
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useSignupMutation } = signupService;
